import {
  ResourceDetailCardBase,
  TableFormElement,
} from "./ResourceDetailCardBase";
import { EditableResourceDetailsProps } from "./MailResourceHelpers";
import { Resource } from "../resourcesSlice";
import * as Yup from "yup";

const tableElements: TableFormElement<Resource>[] = [
  {
    title: "Key identifier",
    key: "officeKey.identifier" as keyof Resource,
    validation: Yup.string().required()
  },
  {
    title: "Rooms accessible",
    key: "officeKey.rooms" as keyof Resource,
  },
];

export const OfficeKey = (
  props: EditableResourceDetailsProps<Resource>
) => (
  <ResourceDetailCardBase {...props}>{tableElements}</ResourceDetailCardBase>
);

export const officeKeyTableElements = tableElements;
